import React from 'react';
import { FormattedMessage } from 'react-intl';
import MessageBox, { MESSAGE_BOX_VARIANT_ERROR } from '@components/2-molecules/MessageBox';

/** Notice shown when a guardrail retracted a message. */
const GuardrailNotice: React.FC = () => (
  <MessageBox variant={MESSAGE_BOX_VARIANT_ERROR} leadingIconName="shield_0">
    <span>
      <FormattedMessage
        id="chat.guardrail.retracted"
        defaultMessage="This response was removed by our safety system."
      />
    </span>
  </MessageBox>
);

export default GuardrailNotice;
